export const landingPagesData = [
    {
        key: 'berlin',
        routeDE: '/parken-berlin',
        routeEN: '/parking-berlin',
        lat: 52.520008,
        lng: 13.404954
    },
    {
        key: 'hamburg',
        routeDE: '/parken-hamburg',
        routeEN: '/parking-hamburg',
        lat: 53.551086,
        lng: 9.993682
    },
    {
        key: 'munich',
        routeDE: '/parken-muenchen',
        routeEN: '/parking-munich',
        lat: 48.135125,
        lng: 11.581981
    },
    {
        key: 'innsbruck',
        routeDE: '/parken-innsbruck',
        routeEN: '/parking-innsbruck',
        lat: 47.268213,
        lng: 11.392773
    }
]
